export default __webpack_public_path__ + "static/media/page7Image1_en.fae1dd50.png";